import { motion } from "framer-motion";

import LinkedInIcon from "../assets/icons/linkedin.svg";
import BehanceIcon from "../assets/icons/behance.svg";
import DribbbleIcon from "../assets/icons/dribbble.svg";

import { BEHANCE_URL, DRIBBBLE_URL, LINKEDIN_URL } from "../layout/contact";
import "./components.css";

function FixedSocials() {
	const SocialIcon = ({ iconSource, link, label }) => {
		const icon = {
			hidden: { scale: 1, opacity: 1 },
			visible: { scale: 1.1, opacity: 1 },
		};

		return (
			<motion.a
				href={link}
				className="social-icon-container"
				variants={icon}
				whileHover="visible"
				initial="hidden"
				target="_blank"
				rel="noopener noreferrer"
				aria-label={label}
			>
				<div className="social-icon">
					<img src={iconSource} alt="" />
				</div>
			</motion.a>
		);
	};

	return (
		<div className="fixed-socials">
			<SocialIcon
				iconSource={LinkedInIcon}
				link={LINKEDIN_URL}
				label="LinkedIn profile (opens in a new tab)"
			/>
			<SocialIcon
				iconSource={BehanceIcon}
				link={BEHANCE_URL}
				label="Behance portfolio (opens in a new tab)"
			/>
			<SocialIcon
				iconSource={DribbbleIcon}
				link={DRIBBBLE_URL}
				label="Dribbble portfolio (opens in a new tab)"
			/>
		</div>
	);
}
export default FixedSocials;
